import { render, staticRenderFns } from "./NotificationPreferences.vue?vue&type=template&id=3ec36a84&"
import script from "./NotificationPreferences.vue?vue&type=script&lang=js&"
export * from "./NotificationPreferences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports